import React, { useState } from 'react';

import { Box, Button, FormikField, H2, ListRow, RadioGroup, Separator, Text } from '@betterment/samba-react';
import { useFormikContext } from 'formik';

import TierTypeExampleModal from './TierTypeExampleModal';

import { TieredFeeCalculationMethod } from '../../../../graphql/schema';

export const BillingTierTypeBox: React.FC = () => {
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const { values, setFieldValue } = useFormikContext<{
    tieredFeeCalculationMethod: TieredFeeCalculationMethod;
  }>();

  const { tieredFeeCalculationMethod } = values;

  return (
    <Box
      css={{
        borderWidth: 'thin',
        borderStyle: 'solid',
        borderColor: 'border',
        borderRadius: 'medium',
        padding: 'space.300',
      }}
    >
      <TierTypeExampleModal isOpen={isModalOpen} closeHandler={() => setModalOpen(false)} />
      <ListRow css={{ padding: 'space.0' }}>
        <ListRow.LeadingContent>
          <H2 variant="title200">Billing tier type</H2>
          <Text color="text.weak" variant="text50">
            Choose how to apply billing tiers.{' '}
            <Button variant="textSecondary" onClick={() => setModalOpen(true)}>
              See example
            </Button>
          </Text>
        </ListRow.LeadingContent>
      </ListRow>
      <Box>
        <Separator css={{ marginTop: 'space.200' }} />
        <FormikField name="tieredFeeCalculationMethod">
          <FormikField.Control>
            <RadioGroup
              onValueChange={(value: TieredFeeCalculationMethod) => {
                void setFieldValue('tieredFeeCalculationMethod', value);
              }}
              value={tieredFeeCalculationMethod}
              aria-labelledby="configurationTypeGroupLabel"
              css={{ gap: '0' }}
            >
              <RadioGroup.ItemContainer css={{ pt: 'space.200' }}>
                <RadioGroup.Item value={TieredFeeCalculationMethod.Progressive} />
                <RadioGroup.ItemLabel>Progressive</RadioGroup.ItemLabel>
              </RadioGroup.ItemContainer>
              <Text variant="text50" color="text.weak" css={{ pt: 'space.50', pl: '28px' }}>
                Each portion of a client’s AUM is charged at the rate for its specific tier.
              </Text>
              <RadioGroup.ItemContainer css={{ pt: 'space.150' }}>
                <RadioGroup.Item value={TieredFeeCalculationMethod.Cliff} />
                <RadioGroup.ItemLabel>Cliff-based</RadioGroup.ItemLabel>
              </RadioGroup.ItemContainer>
              <Text variant="text50" color="text.weak" css={{ pt: 'space.50', pl: '28px' }}>
                If your client’s AUM moves into a different tier, their entire AUM is charged at that tier’s rate.
              </Text>
            </RadioGroup>
          </FormikField.Control>
          <FormikField.ErrorMessage />
        </FormikField>
      </Box>
    </Box>
  );
};
